import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './standby-entry-completion-result.actions';
import { StandbyEntryCompletionResultState } from './standby-entry-completion-result.state';

/**
 * standbyEntryCompletionResult initial state
 */
export const standbyEntryCompletionResultInitialState: StandbyEntryCompletionResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for StandbyEntryCompletionResult Store
 */
export const standbyEntryCompletionResultReducerFeatures: ReducerTypes<
  StandbyEntryCompletionResultState,
  ActionCreator[]
>[] = [
  on(actions.setStandbyEntryCompletionResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateStandbyEntryCompletionResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetStandbyEntryCompletionResult, () => standbyEntryCompletionResultInitialState),

  on(actions.cancelStandbyEntryCompletionResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failStandbyEntryCompletionResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(
    actions.setStandbyEntryCompletionResultFromApi,
    actions.updateStandbyEntryCompletionResultFromApi,
    (state, payload) => asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * StandbyEntryCompletionResult Store reducer
 */
export const standbyEntryCompletionResultReducer = createReducer(
  standbyEntryCompletionResultInitialState,
  ...standbyEntryCompletionResultReducerFeatures
);
